import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { addVoucher, removeVoucher } from "./queries";

export const useAddVoucherMutation = () =>
  useMutation({
    mutationFn: addVoucher,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ["jointBillServicePeriodData", variables.jointBillServiceId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["jointBillServicesExpectedPaymentAmount"],
      });
    },
  });

export const useRemoveVoucherMutation = () =>
  useMutation({
    mutationFn: removeVoucher,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ["jointBillServicePeriodData", variables.jointBillServiceId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["jointBillServicesExpectedPaymentAmount"],
      });
    },
  });
